import { Vector2 } from "three";
import { HSLColor } from "../../../library-js/colors/HSLColor";
import { HTMLColor } from "../../../library-js/colors/HTMLColor";
import { CanvasDrawer } from "../../../library-js/dom/CanvasDrawer";
import { MathX } from "../../../library-js/math/MathX";

export class PlotLineSettings
{
  lineColor:HTMLColor = new HSLColor( 200, 30, 50 );
  lineWidth = 2;
}

export class PlotSettings
{
  backgroundColor = new HSLColor( 220, 20, 10 );
  lineSettings:PlotLineSettings[] = []; 
  lineWidthAll = 2;
  min = new Vector2( 0, 0 );
  max = new Vector2( 1, 1 );
  visualizePoint = 0;

  addLineSetting( color:HTMLColor, lineWidth:number = null )
  {
    let ls = new PlotLineSettings();
    ls.lineColor = color;
    ls.lineWidth = lineWidth;
    this.lineSettings.push( ls );

    return ls;
  }

}